module.exports = __webpack_public_path__ + "static/media/oy_2.24e9f680.mp3";